<script setup lang="ts">
import { ref } from 'vue';
import DireccionConCoordenadas from '@idem/common/components/direccion-con-coordenadas.vue';
import { crearPromocion } from '@frontend/promociones/services/promociones.api';
import { textos } from '@frontend/promociones/textos';

const agregada = ref(false);
const error = ref(false);
const titulo = ref('');
const beneficio = ref('');
const nombreComercio = ref('');
const inicio = ref('');
const fin = ref('');
const descripcion = ref('');
const direccion = ref('');
const imagen = ref<File | undefined>(undefined);
const condiciones = ref('');
const latitud = ref<number | undefined>(undefined);
const longitud = ref<number | undefined>(undefined);

function valorOpcional(valor: string): string | undefined {
  return valor !== '' ? valor : undefined;
}

function asignarCoordenadas(coordenadas: { latitud: number; longitud: number }) {
  latitud.value = coordenadas.latitud;
  longitud.value = coordenadas.longitud;
}

function seleccionarImagen(evento: Event) {
  imagen.value = (evento.target as HTMLInputElement).files?.[0];
}

async function submit() {
  try {
    await crearPromocion(
      {
        titulo: titulo.value,
        beneficio: beneficio.value,
        nombreComercio: nombreComercio.value,
        inicio: inicio.value,
        fin: fin.value,
        descripcion: valorOpcional(descripcion.value),
        direccion: valorOpcional(direccion.value),
        condiciones: valorOpcional(condiciones.value),
        latitud: latitud.value,
        longitud: longitud.value,
      },
      imagen.value,
    );
    agregada.value = true;
    error.value = false;
  } catch {
    error.value = true;
  }
}
</script>

<template>
  <section class="mx-auto max-w-2xl px-4 py-8">
    <h1 class="mb-6 text-2xl font-bold text-gray-900">Agregar promoción</h1>
    <form class="space-y-4" @submit.prevent="submit">
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Título</label>
        <input data-testid="titulo" v-model="titulo" class="w-full rounded border px-3 py-2" />
      </div>
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Beneficio</label>
        <input
          data-testid="beneficio"
          v-model="beneficio"
          class="w-full rounded border px-3 py-2"
        />
      </div>
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Comercio</label>
        <input
          data-testid="nombre-comercio"
          v-model="nombreComercio"
          class="w-full rounded border px-3 py-2"
        />
      </div>
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label class="mb-1 block text-sm font-medium text-gray-700">Inicio</label>
          <input
            data-testid="inicio"
            type="datetime-local"
            v-model="inicio"
            class="w-full rounded border px-3 py-2"
          />
        </div>
        <div>
          <label class="mb-1 block text-sm font-medium text-gray-700">Fin</label>
          <input
            data-testid="fin"
            type="datetime-local"
            v-model="fin"
            class="w-full rounded border px-3 py-2"
          />
        </div>
      </div>
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Descripción</label>
        <input
          data-testid="descripcion"
          v-model="descripcion"
          class="w-full rounded border px-3 py-2"
        />
      </div>
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Dirección</label>
        <direccion-con-coordenadas
          v-model="direccion"
          placeholder="Calle 123, Ciudad"
          class="w-full rounded border px-3 py-2"
          @coordenadas="asignarCoordenadas"
        />
      </div>
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Imagen</label>
        <input
          data-testid="imagen"
          type="file"
          class="w-full text-sm text-gray-700"
          @change="seleccionarImagen"
        />
      </div>
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Condiciones</label>
        <input
          data-testid="condiciones"
          v-model="condiciones"
          class="w-full rounded border px-3 py-2"
        />
      </div>
      <button type="submit" class="rounded bg-teal-600 px-4 py-2 text-white hover:bg-teal-700">
        Agregar
      </button>
    </form>
    <p v-if="agregada" data-testid="promocion-agregada" class="mt-4 text-green-700">
      {{ textos.promocionAgregada }}
    </p>
    <p v-if="error" data-testid="error-agregar-promocion" class="mt-4 text-red-600">
      {{ textos.errorAgregarPromocion }}
    </p>
  </section>
</template>
